import { IHttpApi } from '@cian/http-api';
import { IFastFiltersUserSchema } from '../repositories/monolith-python/entities/schemas/FastFiltersUserSchema';
import { fetchGetUserDataByRequest } from '../repositories/monolith-python/v1/get-user-data-by-request';

export function getUser(httpApi: IHttpApi, headers?: [string, string][]): Promise<IFastFiltersUserSchema> {
  return fetchGetUserDataByRequest({ httpApi, parameters: {}, config: { requestConfig: { headers } } }).then(
    ({ response }) => response.data.user,
  );
}
